// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"52b0f9bb","380":"af231cb8","572":"d39f9771","605":"6a15263f","772":"8d0be914","960":"e72824de"}[chunkId] + ".chunk.js";
};